module.exports = __webpack_public_path__ + "img/survey-dpmptsp.80f1b700.png";